import { equals2, every } from "fxjs/es";
import { CommonNS } from "../../../../Common/CommonNS.js";
import { ModelNS } from "../../Model/ModelNS.js";
import { VONS } from "../../VO/VONS.js";
export class RubberBandController {
  constructor({ rubber_band }) {
    this._observer_set = new Set();
    this._status = "PENDING";
    this._point1 = {
      x: 0,
      y: 0,
    };
    this._point2 = {
      x: 0,
      y: 0,
    };
    rubber_band.subscribe((vo) => this._observeRubberBand(vo));
  }
  subscribe(observer) {
    if (this._observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    observer({
      status: this._status,
      point1: this._point1,
      point2: this._point2,
    });
    this._observer_set.add(observer);
    return () => {
      this._observer_set.delete(observer);
    };
  }
  _observeRubberBand({ status, point1, point2 }) {
    if (
      every(([a, b]) => equals2(a)(b))([
        [this._status, status],
        [this._point1.x, point1.x],
        [this._point1.y, point1.y],
        [this._point2.x, point2.x],
        [this._point2.y, point2.y],
      ])
    ) {
      return;
    }
    this._status = status;
    this._point1 = point1;
    this._point2 = point2;
    this._notify({
      status: this._status,
      point1: this._point1,
      point2: this._point2,
    });
  }
  _notify(rubber_band_vo) {
    for (const observer of this._observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(rubber_band_vo));
    }
  }
}
